<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>VERT.X EVENT BUS</div>
				<h2 waHeading="l" waText>Built-In Real-Time &mdash; No Broker Required</h2>
				<p waBody="m" waColorText="quiet" waText>Opt-in STOMP/WebSocket backed by the Vert.x event bus.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<markdown [data]="mdContent_1186"></markdown>
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Zero Configuration</h3>
							<p waBody="m" waColorText="quiet" waText>The STOMP server starts automatically when the Angular plugin is on the classpath. No environment variables, no broker setup, no additional dependencies.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Plugin Data Push</h3>
							<p waBody="m" waColorText="quiet" waText>AG Grid, FullCalendar, and Chart.js register IWebSocketMessageReceiver implementations to push data to the browser. The pattern is SPI-driven &mdash; register your own receiver to handle any custom message type.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Built-in Receivers</h3>
							<p waBody="m" waColorText="quiet" waText>WebSocketAjaxCallReceiver &#40;ajax&#41;, WebSocketDataRequestCallReceiver &#40;data&#41;, WebSocketDataSendCallReceiver &#40;dataSend&#41;, group management receivers &mdash; all discovered via SPI at startup.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Session &amp; Context Aware</h3>
							<p waBody="m" waColorText="quiet" waText>EventBusService generates a GUID per browser tab and subscribes to private addresses. Session storage and local storage updates arrive as event bus messages.</p>
						</div>
					</wa-card>
				</div>
			</div>
		</div>
	</div>
</div>